import { Avatar, Box, BoxProps } from "@chakra-ui/react";
import Image from "next/image";
import { ImageFragment } from "../article-card";

interface PostAuthorProps extends BoxProps {
  image?: ImageFragment & { alt?: string };
  name: string;
  url: string;
  sx?: BoxProps;
}

export const PostAuthorImage = ({
  image,
  name,
  url,
  sx,
  ...rest
}: PostAuthorProps) => {
  return (
    <Box as="a" href={url} {...rest}>
      <Box
        rounded="full"
        w="50px"
        h="50px"
        position="relative"
        overflow="hidden"
        {...sx}
      >
        {image ? (
          <Image {...image} alt={image.alt ?? image.handle} src={image.url} />
        ) : (
          <Avatar flex="1" name={name} w="full" h="full" />
        )}
      </Box>
    </Box>
  );
};
